import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import Problems from "@/components/sections/Problems";
import Solutions from "@/components/sections/Solutions";
import Diagnostic from "@/components/sections/Diagnostic";
import CaseStudiesSection from "@/components/sections/CaseStudiesSection";
import Stats from "@/components/sections/Stats";
import Testimonials from "@/components/sections/Testimonials";
import CTABand from "@/components/sections/CTABand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Agence numérique à Montréal pour PME"
        description="Développez votre PME grâce au web, à l'IA et à l'automatisation. Diagnostic numérique gratuit. Sites web, SEO local, publicité, chatbots IA — Montréal & Québec."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Passerelle Numérique Inc.",
          "url": "https://passerellenumerique.ca/",
          "inLanguage": "fr-CA",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://passerellenumerique.ca/blog?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <Hero />
      <Problems />
      <Solutions />
      <Diagnostic />
      <CaseStudiesSection />
      <Testimonials />
      <Stats />
      <CTABand />
    </div>
  );
}
